import { ListingType } from '@aloft/toolkit-shared';

import { createContext, useContext } from 'react';

export const PropertyGridListingTypeContext = createContext<ListingType | undefined>(undefined);

export const usePropertyGridListingType = () => useContext(PropertyGridListingTypeContext);
